/**
 * Floating a window beside a point of the page (a right click), kept inside the workspace.
 */
import type { PagePoint } from "../state/nodeAdder";
import type { WindowManager } from "../wm/manager";

/** The size of a window floated by {@link floatNear}, in CSS pixels. */
export interface FloatSize {
  width: number;
  height: number;
}

/**
 * Floats window `id` with its top left just beside `near` (inside the workspace, moved back in
 * when it would stick out). Without a point, or before the workspace is on the page, the window
 * is only opened where it was.
 */
export function floatNear(wm: WindowManager, id: string, near: PagePoint | null, size: FloatSize): void {
  const workspace = document.querySelector(".workspace")?.getBoundingClientRect();
  if (!near || !workspace) return wm.open(id);
  /** `v` brought inside `[0, max]` (0 when the room is too small). */
  const clamp = (v: number, max: number) => Math.max(0, Math.min(v, max));
  wm.float(id, {
    x: clamp(near.x - workspace.left + 12, workspace.width - size.width),
    y: clamp(near.y - workspace.top + 12, workspace.height - size.height),
    ...size,
  });
}
